module.exports = __webpack_public_path__ + "static/main-4cea538a0e942b47efaff3fd4af4e219.jpg";